module.exports = __webpack_public_path__ + "img/cb7e312.png";